module.exports = __webpack_public_path__ + "static/media/Portrait-10052.5bc99989.jpg";